import React from 'react';

const HomePage = () => {
  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content fade-in">
          <h1>Omega Ops Cybernetics Defence Corp.</h1>
          <p><em>Secure. Military-Grade. Resolute.</em></p>
          <a href="#products" className="btn">Explore Our Solutions</a>
        </div>
      </section>

      {/* Cybernetic Hardware Section */}
      <section className="section" id="hardware">
        <div className="container">
          <div className="section-title">
            <h2>Cybernetic Hardware Solutions</h2>
          </div>
          <div className="hardware-content fade-in">
            <p className="centered-text">
            We build military-grade privacy platforms and cutting-edge biometric security
            devices.
            </p>
         
            <div className="hardware-showcase">

              
              <div className="hardware-item">
                <div className="hardware-icon">
                  <div className="tech-circle"></div>
                </div>
                <h3>Omega Vein Lock&trade;</h3>
                <p>Zero-knowledge biometric access</p>
              </div>
              
              <div className="hardware-item">
                <div className="hardware-icon">
                  <div className="tech-circle"></div>
                </div>
                <h3>Omega CyberCap&trade;</h3>
                <p>Neural interface authentication</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="section section-dark">
        <div className="container">
          <div className="section-title">
            <h2>About Us</h2>
          </div>
          <div className="about-container">
            <div className="about-text fade-in">
              <p>
                Omega Ops Cybernetics Defence Corp. is a Canadian-based Corporation with a focus on creating revolutionary cybernetic defence applications for small to large size businesses as well as for the everyday person.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
  <section className="section" id="products">
        <div className="container">
          <div className="section-title">
            <h2>Our Products</h2>
          </div>
          <div className="products-container">
            {/* Product 1 - Omega Void */}
            <div className="product-card fade-in">
              <div className="product-content">
                <h3 className="product-title">Omega Void&trade; Platform</h3>
                <p className="product-desc">
                  A novel digital architecture rooted in ephemeral disclosure and zero-footprint infrastructure. Omega Void&trade; is designed to scale intuitively, respond organically, and adapt endlessly to the invisible flow of user interaction.
                </p>
                <p className="product-desc">
                  "With every single human in the void interfacing 25 times per day, only 0.00002% of the platform is ever touched. Every human being could use the Omega Void&trade; every second of every day for decades — and it still wouldn't leave a mark. That's how vast the void is."– Omega Ops Cybernetics Defence Corp. CEO
                </p>
                <a href="https://www.omegavoid.com" target="_blank" rel="noopener noreferrer" className="btn">
                  Learn More
                </a>
              </div>
            </div>

            {/* Product 2 - Vein Lock */}
            <div className="product-card fade-in">
              <div className="product-content">
                <h3 className="product-title">Omega Vein Lock&trade;</h3>
                <p className="product-desc">
                  A next-generation biometric interface that redefines what it means to verify identity. Built with advanced neurovascular mapping, dynamic thermal response profiling, and challenge-response circuits, this system analyzes live biological input in real time.
                </p>
                <p className="product-desc">
                  Omega Vein Lock™ replaces obsolete passwords, pins, and static biometrics with a living, adaptive protocol — a handshake between man and machine that no impostor can mimic. Unhackable. Inviolable. Unforgettable.
                </p>
                 <p className="product-desc" style={{ fontStyle: 'italic', marginTop: '1rem' }}>
                  Coming 2028-2029
                </p>
                <p className="product-desc">
                  <a href="/Omega_Vein_Lock_Provisional_Patent.pdf" target="_blank" rel="noopener noreferrer" className="btn">
                    View Provisional Patent
                  </a>
                </p>
            
              </div>
            </div>

            {/* Product 3 - Cyber Cap */}
            <div className="product-card fade-in">
              <div className="product-content">
                <h3 className="product-title">Omega CyberCap&trade;</h3>
                <p className="product-desc">
                  The First True Mind-to-Machine Operating System. Fully non-invasive, this state-of-the-art neural interface allows users to think their way through the digital world. No keyboard. No screen. No voice commands. Just thought.
                </p>
                <p className="product-desc">
                  Built for elite professionals, defence applications, creators, and visionaries, Omega CyberCap&trade; uses cutting-edge EEG and fNIRS sensors to interpret thoughts and execute real-time commands for web browsing, messaging, GPS, and live translation.
                </p>
                <p className="product-desc">
                   <p className="product-desc" style={{ fontStyle: 'italic', marginTop: '1rem' }}>
                  Coming 2028-2029
                </p>
                  <a href="/Omega_Cyber_Cap_Provisional_Patent.pdf" target="_blank" rel="noopener noreferrer" className="btn"> 
                    View Provisional Patent
                  </a>
                </p>
               
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section for CyberCap */}
      {/* <section className="section section-dark">
        <div className="container">
          <div className="section-title">
            <h2>Omega Cyber Cap Key Features</h2>
          </div>
          <div className="features-container fade-in">
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <div className="tech-circle"></div>
                </div>
                <h3>Cognitive Web Browsing</h3>
                <p>Navigate the web using only your thoughts, without screens or devices</p>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <div className="tech-circle"></div>
                </div>
                <h3>GPS Navigation</h3>
                <p>Real-time navigation activated by thought alone</p>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <div className="tech-circle"></div>
                </div>
                <h3>Live Translation</h3>
                <p>Seamless translation between languages using brainwave input</p>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <div className="tech-circle"></div>
                </div>
                <h3>Military-Grade Security</h3>
                <p>Cognitive verification with zero-log security</p>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <div className="tech-circle"></div>
                </div>
                <h3>Multi-Mode Control</h3>
                <p>Private, Navigate, Social, and more operational modes</p>
              </div>
              
              <div className="feature-item">
                <div className="feature-icon">
                  <div className="tech-circle"></div>
                </div>
                <h3>Transcript Delivery</h3>
                <p>Automatic transcript delivery to email for records</p>
              </div>
            </div>
            <div className="feature-cta">
              <p>The new OS that is driven by the mind! — Omega Cyber Cap responds to the mind, not machines.</p>
              <a href="https://www.omegavoid.com" target="_blank" rel="noopener noreferrer" className="btn">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section> */}

      {/* Contact Section */}
      <section className="section section-contact" id="contact">
        <div className="contact-background">
          <div className="contact-grid"></div>
        </div>
        <div className="container">
          <div className="section-title contact-title">
            <h2>Get in Touch</h2>
          </div>
          <div className="contact-card">
            <div className="contact-card-content">
              <div className="contact-header">
                <div className="contact-header-icon">
                  <div className="pulse-circle"></div>
                </div>
                <h3>Contact Information</h3>
              </div>
              <p className="contact-message">
                Have questions or want to partner with us? Reach out directly:
              </p>
              <div className="contact-info">
                <div className="contact-item">
                  <div className="contact-item-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                      <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                  </div>
                  <a href="mailto:corporate@omegaopscyberdefence.com" className="contact-link">
                    corporate@omegaopscyberdefence.com 
                  </a>
                  
                </div>
      
              </div>
              <div className="contact-footer">
                <div className="secured-message">
                  <div className="lock-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                  </div>
                  <span>Secure Communication</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;